/**
 * 表格自动处理跨行
 */
export function getAutoRowSpan<T>(
    dataSource: T[],
    currentData: T,
    currentIndex: number | undefined,
    targetProperty: keyof T | (keyof T)[],
): number {
    const rowIndex = currentIndex ?? 0;

    // 如果是第一行默认不处理
    const prevIndex = rowIndex - 1;

    const newTargetProperty = [];
    if (Array.isArray(targetProperty)) {
        newTargetProperty.push(...targetProperty);
    } else {
        newTargetProperty.push(targetProperty);
    }

    if (prevIndex > -1) {
        const prevData = dataSource[prevIndex];

        const hasSameFlag = newTargetProperty.every((targetProperty) => {
            return prevData?.[targetProperty] === currentData?.[targetProperty];
        });

        if (hasSameFlag) {
            return 0;
        }
    }

    let rowSpan = 1;

    for (let i = rowIndex; i < dataSource.length; i++) {
        const currentLocalConfig = dataSource[i];

        const nextLocalConfig = dataSource[i + 1];

        const hasSameFlag = newTargetProperty.every((targetProperty) => {
            return nextLocalConfig?.[targetProperty] === currentLocalConfig?.[targetProperty];
        });

        if (hasSameFlag) {
            rowSpan++;
        } else {
            break;
        }
    }

    return rowSpan;
}
